<nav [ngClass]="{ active: isActive }" id="sidebar" *ngIf="currentModule">
    <ng-container *ngIf="configMode; else moduleSidebar">
        <ul class="list-unstyled components">
            <li class="fhd-sidebar-childModule config-sidebar-item" data-id="configSidebarOverview"
                [ngClass]="{ isSelected: !activeSectionKey }" (click)="openConfigOverview()">
                <a title="{{ configOverview.labelKey | translate }}">
                    <mat-icon class="config-sidebar-icon">{{ configOverview.icon }}</mat-icon>
                    <span class="padding" *ngIf="!isActive">{{ configOverview.labelKey | translate }}</span>
                </a>
            </li>
            <ng-container *ngFor="let entry of configGroups">
                <li class="config-sidebar-group" *ngIf="!isActive"
                    [attr.data-id]="entry.group.key + 'SidebarGroup'">{{ entry.group.labelKey | translate }}</li>
                <li class="fhd-sidebar-childModule config-sidebar-item" *ngFor="let section of entry.sections"
                    [attr.data-id]="section.key + 'SidebarItem'"
                    [ngClass]="{ isSelected: section.key === activeSectionKey }"
                    (click)="openConfigSection(section)">
                    <a title="{{ section.labelKey | translate }}">
                        <mat-icon class="config-sidebar-icon">{{ section.icon }}</mat-icon>
                        <span class="padding" *ngIf="!isActive">{{ section.labelKey | translate }}</span>
                    </a>
                </li>
            </ng-container>
            <ng-container [ngTemplateOutlet]="toggleRow"></ng-container>
        </ul>
    </ng-container>
    <ng-template #moduleSidebar>
        <ul class="list-unstyled components">
            <li class="fhd-sidebar-childModule" *ngFor="let item of sidebarItems" (click)="toggleClassAlink(item)"
                [ngClass]="{ isSelected: item.isSelected, hidden: item.class === 'hide' }">
                <a title="{{item.name | translate}}">
                    <i class="{{ item.class }}"></i><span class="padding" *ngIf="!isActive">{{ item.name | translate
                        }}</span>
                </a>
            </li>
            <ng-container [ngTemplateOutlet]="toggleRow"></ng-container>
        </ul>
    </ng-template>
    <ng-template #toggleRow>
        <li class="sidebar-toggle">
            <a *ngIf="isActive" (click)="toggleClass()" title="{{ '@expandSidebar' | translate }}">
                <i class="fa fa-angle-double-right"></i>
            </a>
            <a *ngIf="!isActive" (click)="toggleClass()" title="{{ '@collapseSidebar' | translate }}">
                <i class="fa fa-angle-double-left"></i>
            </a>
        </li>
    </ng-template>
</nav>
